export default __webpack_public_path__ + "static/media/published.38d72190.png";